import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, useMemo } from 'react';
type Params = {
  defaultPage?: number;
  itemsPerPage?: number;
};
const getRangeFromPage = (page: number, itemsPerPage: number) => {
  const rangeStart = itemsPerPage * (page - 1);
  const rangeEnd = rangeStart + itemsPerPage - 1;
  return {
    rangeStart,
    rangeEnd
  };
};
export default function usePagination(t0) {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    defaultPage: t2,
    itemsPerPage: t3
  } = t1;
  const defaultPage = t2 === undefined ? 1 : t2;
  const itemsPerPage = t3 === undefined ? 20 : t3;
  const [page, setPage] = useState(defaultPage);
  let t4;
  if ($[2] !== itemsPerPage || $[3] !== page) {
    t4 = getRangeFromPage(page, itemsPerPage);
    $[2] = itemsPerPage;
    $[3] = page;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const pagination = t4;
  let t5;
  if ($[5] !== itemsPerPage || $[6] !== pagination.rangeStart) {
    t5 = () => Math.floor(pagination.rangeStart / itemsPerPage) + 1;
    $[5] = itemsPerPage;
    $[6] = pagination.rangeStart;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const getCurrentPage = t5;
  let t6;
  if ($[8] !== itemsPerPage) {
    t6 = t7 => {
      const totalItems = t7 === undefined ? 0 : t7;
      return Math.ceil(totalItems / itemsPerPage);
    };
    $[8] = itemsPerPage;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const getTotalPages = t6;
  let t7;
  if ($[10] !== getCurrentPage || $[11] !== getTotalPages || $[12] !== pagination) {
    t7 = {
      pagination,
      fetchPage: setPage,
      getCurrentPage,
      getTotalPages
    };
    $[10] = getCurrentPage;
    $[11] = getTotalPages;
    $[12] = pagination;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const objectToReturn = t7;
  return objectToReturn;
}